import { render, staticRenderFns } from "./ContractTemplate.vue?vue&type=template&id=47ad897c&scoped=true"
import script from "./ContractTemplate.vue?vue&type=script&lang=js"
export * from "./ContractTemplate.vue?vue&type=script&lang=js"
import style0 from "./ContractTemplate.vue?vue&type=style&index=0&id=47ad897c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad897c",
  null
  
)

export default component.exports